import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-robot-2-line text-background-50 text-base"></i>
              </div>
              <span className="text-base font-semibold text-foreground-900 font-heading">
                {siteConfig.name}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为成年人打造的AI智能助手，提供更深度的专业支持和更强大的智能能力。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/features" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">功能特色</Link>
              <Link to="/category/tutorials" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">使用教程</Link>
              <Link to="/category/download" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">下载指南</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              帮助中心
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">关于我们</Link>
              <Link to="/category/qa" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">常见问题</Link>
              <Link to="/category/comparison" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">版本对比</Link>
              <a href="#contact" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              联系方式
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-600">{siteConfig.address}</span>
              <span className="text-sm text-foreground-600">{siteConfig.contactEmail}</span>
              <span className="text-sm text-foreground-600">{siteConfig.contactPhone}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteConfig.name} 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}